











import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class SwitchButton extends Vue {
  @Prop({ default: "" }) type!: string;
  @Prop({ required: true }) status!: string;
  @Prop({ default: "保存中" }) progressingText!: string;
  @Prop({ default: "保存" }) defaultText!: string;

  get text() {
    if (this.status === "progressing") {
      return this.progressingText;
    }
    return this.defaultText;
  }

  get variant() {
    if (this.status === "progressing") {
      return "secondary";
    }
    return "primary";
  }

  get disabled() {
    return this.status === "progressing";
  }
}
